import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import {DataGrid as DXDataGrid} from 'devextreme-react';


export default class DDDataGrid extends Component {
    constructor(props) {
        super(props);

        this.dataGridRef = React.createRef();

        this.state = {
            dataSource: this.props.dataSource,
            filterValue: this.props.filterValue,
            // visible: this.props.visible,
            defaultSelectedRowKeys: this.props.defaultSelectedRowKeys,
            columnsUpdateOption: undefined,
            addDroppedRow: undefined,
            removeDroppedRow: undefined,
        };

        this.rowTemplate = this.rowTemplate.bind(this);
        this.cellTemplate = this.cellTemplate.bind(this);
        this.headerCellTemplate = this.headerCellTemplate.bind(this);
        this.groupCellTemplate = this.groupCellTemplate.bind(this);
        this._processCellTemplate = this._processCellTemplate.bind(this);

        this.onCellClick = this.onCellClick.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
        this.onRowDblClick = this.onRowDblClick.bind(this);

        this.onRowRemoving = this.onRowRemoving.bind(this);
        this.onRowRemoved = this.onRowRemoved.bind(this);
        this.onRowUpdating = this.onRowUpdating.bind(this);
        this.onRowUpdated = this.onRowUpdated.bind(this);

        this.onDragStart = this.onDragStart.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.onDragMove = this.onDragMove.bind(this);
        this.onDragChange = this.onDragChange.bind(this);
        this.onReorder = this.onReorder.bind(this);

        this.onOptionChanged = this.onOptionChanged.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        // console.log('componentWillReceiveProps', props)
        if (this.state.dataSource !== props.dataSource) {
            this.setState({
                dataSource: props.dataSource,
            });
        }
        if (this.state.filterValue !== props.filterValue) {
            this.setState({
                filterValue: props.filterValue,
            });
        }
        if (this.state.defaultSelectedRowKeys !== props.defaultSelectedRowKeys) {
            this.setState({
                defaultSelectedRowKeys: props.defaultSelectedRowKeys,
            });
        }
        if (this.state.columnsUpdateOption !== props.columnsUpdateOption) {
            this.setState({
                columnsUpdateOption: props.columnsUpdateOption,
            });

            Object.keys(props.columnsUpdateOption || {}).forEach((key, index) => {
                let opts = props.columnsUpdateOption[key];
                if (opts.sortingMethod && typeof opts.sortingMethod === 'string')
                    opts.sortingMethod = window[opts.sortingMethod];

                if (opts.sortOrder && this.dataGrid.columnOption(key, 'sortOrder') === opts.sortOrder)
                    this.dataGrid.columnOption(key, 'sortOrder', undefined)
                this.dataGrid.columnOption(key, opts)
            })
        }
        if (this.state.addDroppedRow !== props.addDroppedRow) {
            // console.log('addDroppedRow', props.addDroppedRow)
            if (props.addDroppedRow) {
                const tasks = this.state.dataSource;
                const fromRows = this.dataGrid.getVisibleRows();
                // // const targetData = fromRows[props.addDroppedRow.fromIndex].data;
                const targetIndex = fromRows.length <= props.addDroppedRow.fromIndex ? fromRows.length : tasks.indexOf(fromRows[props.addDroppedRow.fromIndex].data);
                // const targetIndex = fromRows.length <= props.addDroppedRow.fromIndex ? fromRows.length : tasks.indexOf(props.addDroppedRow.data);
                // const getRowIndexByKey = this.dataGrid.getRowIndexByKey(this.dataGrid.keyOf(props.addDroppedRow.data));
                // console.log('addDroppedRow getRowIndexByKey', getRowIndexByKey)
                // const targetIndex = tasks.indexOf(fromRows[getRowIndexByKey].data);
                // console.log('addDroppedRow targetIndex', targetIndex)
                let t;
                if (this.props.rowDragging.clone) {
                    t = [...tasks.slice(0, targetIndex), props.addDroppedRow.data, ...tasks.slice(targetIndex + 1)];
                } else {
                    t = [...tasks.slice(0, targetIndex), props.addDroppedRow.data, ...tasks.slice(targetIndex)];
                }

                // if (this.props.rowDragging.clone) {
                //     let itemData = R.clone(props.addDroppedRow.data)
                //     (this.props.rowDragging.replaceDataBeforeAdd || []).forEach(d => {
                //         let fields = d.split('.');
                //         if (fields.length === 1)
                //             itemData[fields[0]] = targetData[fields[0]];
                //         else {
                //             itemData[fields[0]] = itemData[fields[0]] || {};
                //             itemData[fields[0]][fields[1]] = targetData[fields[0]][fields[1]];
                //         }
                //     });
                //     t = [...tasks.slice(0, targetIndex), itemData, ...tasks.slice(targetIndex + 1)];
                // } else {
                //     t = [...tasks.slice(0, targetIndex), props.addDroppedRow.data, ...tasks.slice(targetIndex)];
                // }

                this.setState({
                    addDroppedRow: props.addDroppedRow,
                    dataSource: t,
                });
                if (this.props.setProps) this.props.setProps({dataSource: t})
            } else {
                this.setState({
                    addDroppedRow: props.addDroppedRow,
                });
            }
        }
        if (this.state.removeDroppedRow !== props.removeDroppedRow) {
            // console.log('removeDroppedRow', props.removeDroppedRow)
            if (props.removeDroppedRow) {
                const tasks = this.state.dataSource;

                const toRows = this.dataGrid.getVisibleRows();

                // console.log('tasks.indexOf data', tasks.indexOf(props.removeDroppedRow.data))
                // console.log('dataGrid keyOf', this.dataGrid.keyOf(props.removeDroppedRow.data))
                const rowIndex = this.dataGrid.getRowIndexByKey(this.dataGrid.keyOf(props.removeDroppedRow.data));
                // console.log('dataGrid getRowIndexByKey', rowIndex)
                let targetData
                let targetIndex
                if (rowIndex >= 0) {
                    const row = toRows[rowIndex]
                    // console.log('toRows row', row)
                    targetData = row.data;
                    // console.log('toRows targetData', targetData)
                    targetIndex = tasks.indexOf(targetData);
                    // const targetIndex = props.removeDroppedRow.toIndex;
                    // console.log('removeDroppedRow targetIndex', targetIndex)
                } else {
                    // console.log('getDataSource', this.dataGrid.getDataSource())
                    // console.log('getDataSource data', this.dataGrid.getDataSource()[props.removeDroppedRow.toIndex])
                    // this.dataGrid.deleteRow(rowIndex)
                    targetIndex = props.removeDroppedRow.toIndex
                    targetData = tasks[targetIndex]
                    // console.log('tasks targetData', targetData)
                }
                // const targetIndex = tasks.indexOf(props.removeDroppedRow.data);
                let t;
                // if (this.props.rowDragging.allowDropInsideItem) {
                //     t = [...tasks.slice(0, targetIndex), props.removeDroppedRow.data, ...tasks.slice(targetIndex + 1)];
                // } else {
                //     t = [...tasks.slice(0, targetIndex), ...tasks.slice(targetIndex + 1)];
                // }

                if (this.props.rowDragging.allowDropInsideItem) {
                    let itemData = R.clone(props.removeDroppedRow.prevData || props.removeDroppedRow.data)
                    if (!props.removeDroppedRow.prevData) {
                        const data = this.props.rowDragging.replaceDataAfterClone || {};
                        for (let field in data) {
                            if (!data.hasOwnProperty(field)) continue;
                            let fields = field.split('.');
                            if (fields.length === 1) {
                                itemData[fields[0]] = targetData[fields[0]];
                            }
                            else {
                                itemData[fields[0]] = itemData[fields[0]] || {};
                                itemData[fields[0]][fields[1]] = data[field];
                            }
                        }
                    }

                    // console.log('onRemove replaceDataAfterClone', itemData)

                    t = [...tasks.slice(0, targetIndex), itemData, ...tasks.slice(targetIndex + 1)];
                } else {
                    t = [...tasks.slice(0, targetIndex), ...tasks.slice(targetIndex + 1)];
                }

                this.setState({
                    removeDroppedRow: props.removeDroppedRow,
                    dataSource: t,
                });
                if (this.props.setProps) this.props.setProps({dataSource: t})
            } else {
                this.setState({
                    removeDroppedRow: props.removeDroppedRow,
                });
            }
        }
        // if (this.state.visible !== props.visible) {
        //     this.setState({visible: props.visible});
        // }
    }

    get dataGrid() {
        return this.dataGridRef.current.instance;
    }

    rowTemplate(template_id) {
        var tmpl = window[template_id];
        return function(container, options) {
            const d = window.document.createElement('table');
            ReactDOM.render(tmpl(options), d);
            container.append(d.firstChild);
            d.remove();
        }
    }

    cellTemplate(template_id) {
        var tmpl = window[template_id];
        return function(container, options) {
            ReactDOM.render(tmpl(options), container);
        }
    }

    headerCellTemplate(template_id) {
        var tmpl = window[template_id];
        return function(container, options) {
            ReactDOM.render(tmpl(options), container);
        }
    }

    groupCellTemplate(template_id) {
        var tmpl = window[template_id];
        return function(container, options) {
            ReactDOM.render(tmpl(options), container);
        }
    }

    _processCellTemplate(columns) {
        for(const c in columns){
            if (columns[c].cellTemplate && typeof columns[c].cellTemplate === 'string') {
                columns[c].cellTemplate = this.cellTemplate(columns[c].cellTemplate);
            }
            if (columns[c].groupCellTemplate && typeof columns[c].groupCellTemplate === 'string') {
                columns[c].groupCellTemplate = this.groupCellTemplate(columns[c].groupCellTemplate);
            }
            if (columns[c].headerCellTemplate && typeof columns[c].headerCellTemplate === 'string') {
                columns[c].headerCellTemplate = this.headerCellTemplate(columns[c].headerCellTemplate);
            }
            if (columns[c].columns && typeof columns[c].columns === 'object') {
                this._processCellTemplate(columns[c].columns);
            }
            if (columns[c].sortingMethod && typeof columns[c].sortingMethod === 'string') {
                columns[c].sortingMethod = window[columns[c].sortingMethod];
            }
        }
    }

    onCellClick(e) {
        const {setProps} = this.props;

        // console.log('onCellClick', e)
        if (e.rowType === 'data' && setProps) {
            const data = {
                cellClick: {
                    rowType: e.rowType,
                    row: {
                        isEditing: e.row.isEditing,
                        isExpanded: e.row.isExpanded,
                        isSelected: e.row.isSelected,
                    },
                    rowIndex: e.rowIndex,
                    columnIndex: e.columnIndex,
                    dataField: e.column.dataField,
                    key: e.key,
                    text: e.text,
                    value: e.value,
                    timestamp: Date.now()
                }
            };
            setProps(data);
        }
    }

    onRowClick(e) {
        // console.log('onRowClick', e)
        const {setProps} = this.props;

        if (setProps) {
            setProps({
                rowClick: {
                    data: e.data,
                    key: e.key,
                    timestamp: Date.now()
                }
            });
        }

        // e.cancel = true;
    }

    onRowDblClick(e) {
        // console.log('onRowDblClick', e)
        const {setProps} = this.props;

        if (setProps) {
            setProps({
                rowDblClick: {
                    data: e.data,
                    key: e.key,
                    timestamp: Date.now()
                }
            });
        }
    }

    onRowRemoved(e) {
        // console.log('onRowRemoved', this.props.rowDragging.data, e)
        const {setProps} = this.props;

        if (setProps) {
            setProps({
                rowRemoved: {
                    data: e.data,
                    key: e.key,
                    timestamp: Date.now()
                }
            });
        }
    }

    onRowRemoving(e) {
        // console.log('onRowRemoving', this.props.rowDragging.data, e)
        const {setProps} = this.props;

        if (setProps) {
            setProps({
                rowRemoving: {
                    data: e.data,
                    key: e.key,
                    timestamp: Date.now()
                }
            });
        }

        // e.cancel = true;
    }

    onRowUpdated(e) {
        // console.log('onRowUpdated', this.props.rowDragging.data, e)
        const {setProps} = this.props;

        if (setProps) {
            setProps({
                rowUpdated: {
                    data: e.data,
                    key: e.key,
                    timestamp: Date.now()
                }
            });
        }

        // e.cancel = true;
    }

    onRowUpdating(e) {
        // console.log('onRowUpdating', this.props.rowDragging.data, e)
        const {setProps} = this.props;

        if (setProps) {
            setProps({
                rowUpdating: {
                    data: e.data,
                    key: e.key,
                    timestamp: Date.now()
                }
            });
        }
    }

    onDragStart(e) {
        // console.log('onDragStart', this.props.rowDragging.data, e)
        const rows = this.dataGrid.getVisibleRows();
        // console.log('onDragStart rows', rows)

        // const sourceNode = e.component.getNodeByKey(e.itemData.id);
        // console.log('onDragStart sourceNode', sourceNode)
        // targetNode = visibleRows[e.toIndex].node;

        // console.log('onDragStart selectedItems', this.state.selectedItem)
        // console.log('onDragStart dataSource', this.state.dataSource)
        // e.itemData = (this.state.items || this.state.dataSource.store)[e.fromIndex];
        // e.itemData = this.state.dataSource[e.fromIndex];
        e.itemData = rows[e.fromIndex].data;

        if (this.props.rowDragging.dragStartField) {
            // const fields = this.props.rowDragging.dragStartField.split('.');
            // let v;
            // if (fields.length === 1) {
            //     v = e.itemData[fields[0]];
            // } else v = e.itemData[fields[0]][fields[1]];
            //
            // if (!v) {
            //     e.cancel = true;
            //     return false;
            // }
            if (!R.path(this.props.rowDragging.dragStartField.split('.'), e.itemData)) {
                e.cancel = true;
                return false;
            }
        }

        // console.log('onDragStart itemData', e.itemData);

        const {setProps} = this.props;

        if (setProps) {
            setProps({
                dragStart: {
                    fromData: e.fromData,
                    fromIndex: e.fromIndex,
                    data: e.itemData,
                    timestamp: Date.now()
                }
            });
        }
    }

    onDragEnd(e) {
        // console.log('onDragEnd', this.props.rowDragging.data, e)
    }

    onReorder(e) {
        // console.log('onReorder', this.props.rowDragging.data, e)
    }

    onAdd(e) {
        // console.log('onAdd', this.props.rowDragging.data, e)
        // console.log('onAdd rowDragging', this.props.rowDragging)
        // console.log('onAdd name', e.fromComponent.NAME)
        // if (e.fromComponent.NAME === 'dxDataGrid') {
        //     const fromRows = e.fromComponent.getVisibleRows();
        //     console.log('onAdd fromRows', fromRows)
        //     console.log('onAdd getRowIndexByKey', e.fromComponent.getRowIndexByKey(e.itemData.id))
        // }

        const tasks = this.state.dataSource;
        let t;
        let targetIndex = e.toIndex;
        let prevData = {};
        if (this.props.rowDragging.allowDropInsideItem) {
            const toRows = e.toComponent.getVisibleRows();
            // console.log('onAdd toRows', toRows);

            const targetData = toRows[e.toIndex].data;
            prevData = {prevData: targetData};
            targetIndex = tasks.indexOf(targetData);

            (this.props.rowDragging.replaceDataBeforeAdd || []).forEach(d => {
                let fields = d.split('.');
                if (fields.length === 1)
                    e.itemData[fields[0]] = targetData[fields[0]];
                else {
                    e.itemData[fields[0]] = e.itemData[fields[0]] || {};
                    e.itemData[fields[0]][fields[1]] = targetData[fields[0]][fields[1]];
                }
            });
            t = [...tasks.slice(0, targetIndex), e.itemData, ...tasks.slice(targetIndex + 1)];
        } else {
            t = [...tasks.slice(0, targetIndex), e.itemData, ...tasks.slice(targetIndex)];
        }

        const {setProps} = this.props;

        if (setProps) {
            setProps({
                dropAdd: {
                    fromData: e.fromData,
                    fromIndex: e.fromIndex,
                    toData: e.toData,
                    toIndex: e.toIndex,
                    // targetIndex: targetIndex,
                    data: e.itemData,
                    timestamp: Date.now(),
                    ...prevData,
                },
                dataSource: t
            });
        }

        this.setState({
            dataSource: t
        });
    }

    onRemove(e) {
        // console.log('onRemove', this.props.rowDragging.data, e)
        const {setProps} = this.props;
        const tasks = this.state.dataSource;
        const fromIndex = tasks.indexOf(e.itemData)
        let t;
        let itemData = R.clone(e.itemData)
        if (this.props.rowDragging.clone) {
            const data = this.props.rowDragging.replaceDataAfterClone || {};
            // let itemData = {...e.itemData};

            for (let field in data) {
                if (!data.hasOwnProperty(field)) continue;
                let fields = field.split('.');
                if (fields.length === 1) {
                    itemData[fields[0]] = targetData[fields[0]];
                }
                else {
                    itemData[fields[0]] = itemData[fields[0]] || {};
                    itemData[fields[0]][fields[1]] = data[field];
                }
            }
            // console.log('onRemove replaceDataAfterClone', itemData)

            t = [...tasks.slice(0, fromIndex), itemData, ...tasks.slice(fromIndex + 1)];

            if (setProps) {
                setProps({
                    dragClone: {
                        fromData: e.fromData,
                        fromIndex: e.fromIndex,
                        toData: e.toData,
                        toIndex: e.toIndex,
                        data: itemData,
                        timestamp: Date.now()
                    }
                });
            }
        } else {
            t = [...tasks.slice(0, fromIndex), ...tasks.slice(fromIndex + 1)];
        }

        // e.component.removeDroppedRow(e.fromIndex)

        this.setState({
            dataSource: t
        });

        if (setProps) {
            setProps({
                dragRemove: {
                    fromData: e.fromData,
                    fromIndex: e.fromIndex,
                    toData: e.toData,
                    toIndex: e.toIndex,
                    data: e.itemData,
                    timestamp: Date.now()
                },
                dataSource: t
            });
        }
    }

    onDragMove(e) {
        // console.log('onDragMove', this.props.rowDragging.data, e)
    }

    onDragChange(e) {
         // console.log('onDragChange', this.props.rowDragging.data, e)

        const toRows = e.toComponent.getVisibleRows()

        if (!this.props.rowDragging.allowDropInsideItemForSameTable && e.toData === e.fromData) {
            e.cancel = true;
        }
        if (this.props.rowDragging.allowDropInsideItem) {
            if ((toRows.length <= e.toIndex) || (toRows[e.toIndex].rowType === 'group') || !e.dropInsideItem) {
                e.cancel = true;
                // return false;
            }
        }

        if (this.props.rowDragging.dragStartField2) {
            if (R.path(this.props.rowDragging.dragStartField2.split('.'), toRows[e.toIndex].data)) {
                e.cancel = true;
                // return false;
            }
        }
    }

    onOptionChanged(e) {
        if(e.name === 'filterValue') {
            this.setState({
                filterValue: e.value,
            });
            // const {setProps} = this.props;
            // if (setProps) setProps(
            //     {filterValue: e.value}
            // )
        }
    }

    render() {
        const {columns} = this.props;
        let {rowTemplate} = this.props;
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }

        this._processCellTemplate(columns);

        if (rowTemplate && typeof rowTemplate === 'string'){
            rowTemplate = this.rowTemplate(rowTemplate);
        }

        const rowDragging = this.props.rowDragging || {};
        rowDragging.onDragStart = this.onDragStart;
        rowDragging.onDragEnd = this.onDragEnd;
        rowDragging.onAdd = this.onAdd;
        rowDragging.onRemove = this.onRemove;
        rowDragging.onDragMove = this.onDragMove;
        rowDragging.onDragChange = this.onDragChange;
        rowDragging.onReorder = this.onReorder;

        return (
            <DXDataGrid
                {...R.omit(['loading_state', 'setProps'], this.props)}
                {...dataAttributes}
                ref={this.dataGridRef}
                dataSource={this.state.dataSource}
                defaultSelectedRowKeys={this.state.defaultSelectedRowKeys}
                // visible={this.state.visible}
                columns={columns}
                rowTemplate={rowTemplate}
                rowDragging={rowDragging}
                onCellClick={this.props.onCellClick || this.onCellClick}
                onRowClick={this.props.onRowClick || this.onRowClick}
                onRowDblClick={this.props.onRowDblClick || this.onRowDblClick}
                onRowRemoved={this.props.onRowRemoved || this.onRowRemoved}
                onRowRemoving={this.props.onRowRemoving || this.onRowRemoving}
                onRowUpdated={this.props.onRowUpdated || this.onRowUpdated}
                onRowUpdating={this.props.onRowUpdating || this.onRowUpdating}
                onOptionChanged={this.props.onOptionChanged || this.onOptionChanged}
                filterValue={this.state.filterValue}
            />
        );
    }
}

DDDataGrid.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    /**
     * Specifies the shortcut key that sets focus on the UI component
     */
    accessKey: PropTypes.string,
    /**
     * Specifies whether or not the UI component changes its state when interacting with a user
     */
    activeStateEnabled: PropTypes.bool,
    /**
     * Dash event
     */
    addDroppedRow: PropTypes.object,
    /**
     * Specifies whether a user can reorder columns
     */
    allowColumnReordering: PropTypes.bool,
    /**
     * Specifies whether a user can resize columns
     */
    allowColumnResizing: PropTypes.bool,
    /**
     * Automatically scrolls to the focused row when the focusedRowKey is changed
     */
    autoNavigateToFocusedRow: PropTypes.bool,
    /**
     * Specifies whether data should be cached
     */
    cacheEnabled: PropTypes.bool,
    /**
     * Dash event
     */
    cellClick: PropTypes.object,
    /**
     * Enables a hint that appears when a user hovers the mouse pointer over a cell with truncated content
     */
    cellHintEnabled: PropTypes.bool,
    /**
     * Specifies whether columns should adjust their widths to the content
     */
    columnAutoWidth: PropTypes.bool,
    /**
     * Configures the column chooser
     */
    columnChooser: PropTypes.object,
    /**
     * Configures column fixing
     */
    columnFixing: PropTypes.object,
    /**
     * Specifies whether the UI component should hide columns to adapt to the screen or container size. Ignored if allowColumnResizing is true and columnResizingMode is "widget"
     */
    columnHidingEnabled: PropTypes.bool,
    /**
     * Specifies the minimum width of columns
     */
    columnMinWidth: PropTypes.number,
    /**
     * Specifies how the UI component resizes columns. Applies only if allowColumnResizing is true.
     */
    columnResizingMode: PropTypes.oneOf(['nextColumn', 'widget']),
    /**
     * An array of grid columns
     */
    columns: PropTypes.arrayOf(PropTypes.object),
    /**
     * Dash option to update column options
     */
    columnsUpdateOption: PropTypes.object,
    /**
     * Specifies the width for all data columns. Has a lower priority than the column.width property.
     */
    columnWidth: PropTypes.number,
    /**
     * Customizes columns after they are created
     */
    customizeColumns: PropTypes.func,
    /**
     * Binds the UI component to data
     */
    dataSource: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
    /**
     * Specifies the format in which date-time values should be sent to the server. Use it only if you do not specify the dataSource at design time
     */
    dateSerializationFormat: PropTypes.string,
    /**
     * Allows you to select rows or determine which rows are selected
     */
    defaultSelectedRowKeys: PropTypes.arrayOf(PropTypes.any),
    /**
     * Specifies whether the UI component responds to user interaction
     */
    disabled: PropTypes.bool,
    /**
     * Dash event
     */
    dragClone: PropTypes.object,
    /**
     * Dash event
     */
    dragRemove: PropTypes.object,
    /**
     * Dash event
     */
    dragStart: PropTypes.object,
    /**
     * Dash event
     */
    dropAdd: PropTypes.object,
    /**
     * Configures editing
     */
    editing: PropTypes.object,
    /**
     * Specifies the global attributes to be attached to the UI component's container element
     */
    elementAttr: PropTypes.object,
    /**
     * Indicates whether to show the error row
     */
    errorRowEnabled: PropTypes.bool,
    /**
     * Configures client-side exporting
     */
    export: PropTypes.object,
    /**
     * Configures the integrated filter builder
     */
    filterBuilder: PropTypes.object,
    /**
     * Configures the popup in which the integrated filter builder is shown
     */
    filterBuilderPopup: PropTypes.object,
    /**
     * Configures the filter panel
     */
    filterPanel: PropTypes.object,
    /**
     * Configures the filter row
     */
    filterRow: PropTypes.object,
    /**
     * Specifies whether to synchronize the filter row, header filter, and filter builder. The synchronized filter expression is stored in the filterValue property.
     */
    filterSyncEnabled: PropTypes.bool,
    /**
     * Specifies a filter expression
     */
    filterValue: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    /**
     * The index of the column that contains the focused data cell. This index is taken from the columns array.
     */
    focusedColumnIndex: PropTypes.number,
    /**
     * Specifies whether the focused row feature is enabled
     */
    focusedRowEnabled: PropTypes.bool,
    /**
     * Specifies or indicates the focused data row's index. Use this property when focusedRowEnabled is true.
     */
    focusedRowIndex: PropTypes.number,
    /**
     * Specifies initially or currently focused grid row's key. Use it when focusedRowEnabled is true.
     */
    focusedRowKey: PropTypes.any,
    /**
     * Specifies whether the UI component can be focused using keyboard navigation
     */
    focusStateEnabled: PropTypes.bool,
    /**
     * Configures grouping
     */
    grouping: PropTypes.object,
    /**
     * Configures the group panel
     */
    groupPanel: PropTypes.object,
    /**
     * Configures the header filter feature
     */
    headerFilter: PropTypes.object,
    /**
     * Specifies the UI component's height
     */
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies whether to highlight rows and cells with edited data. repaintChangesOnly should be true.
     */
    highlightChanges: PropTypes.bool,
    /**
     * Specifies text for a hint that appears when a user pauses on the UI component
     */
    hint: PropTypes.string,
    /**
     * Specifies whether to highlight rows when a user moves the mouse pointer over them
     */
    hoverStateEnabled: PropTypes.bool,
    /**
     * Configures keyboard navigation
     */
    keyboardNavigation: PropTypes.object,
    /**
     * Specifies the key property (or properties) that provide(s) key values to access data items. Each key value must be unique. This property applies only if data is a simple array.
     */
    keyExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    /**
     * Configures the load panel
     */
    loadPanel: PropTypes.object,
    /**
     * Allows you to build a master-detail interface in the grid
     */
    masterDetail: PropTypes.object,
    /**
     * Specifies text shown when the UI component does not display any data
     */
    noDataText: PropTypes.string,
    /**
     * A function that is executed before an adaptive detail row is rendered
     */
    onAdaptiveDetailRowPreparing: PropTypes.func,
    /**
     * A function that is executed when a cell is clicked or tapped. Executed before onRowClick.
     */
    onCellClick: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    /**
     * A function that is executed when a cell is double-clicked or double-tapped. Executed before onRowDblClick.
     */
    onCellDblClick: PropTypes.func,
    /**
     * A function that is executed after the pointer enters or leaves a cell
     */
    onCellHoverChanged: PropTypes.func,
    /**
     * A function that is executed after a cell is created
     */
    onCellPrepared: PropTypes.func,
    /**
     * A function that is executed when the UI component's content is ready and each time the content is changed
     */
    onContentReady: PropTypes.func,
    /**
     * A function that is executed before the context menu is rendered
     */
    onContextMenuPreparing: PropTypes.func,
    /**
     * A function that is executed when an error occurs in the data source
     */
    onDataErrorOccurred: PropTypes.func,
    /**
     * A function that is executed before the UI component is disposed of
     */
    onDisposing: PropTypes.func,
    /**
     * A function that is executed after row changes are discarded
     */
    onEditCanceled: PropTypes.func,
    /**
     * A function that is executed when the edit operation is canceled, but row changes are not yet discarded
     */
    onEditCanceling: PropTypes.func,
    /**
     * A function that is executed before a cell or row switches to the editing state
     */
    onEditingStart: PropTypes.func,
    /**
     * A function that is executed after an editor is created. Not executed for cells with an editCellTemplate.
     */
    onEditorPrepared: PropTypes.func,
    /**
     * A function used to customize a cell's editor. Not executed for cells with an editCellTemplate.
     */
    onEditorPreparing: PropTypes.func,
    /**
     * A function that is executed before data is exported
     */
    onExporting: PropTypes.func,
    /**
     * A function that is executed after the focused cell changes. Applies only to cells in data or group rows.
     */
    onFocusedCellChanged: PropTypes.func,
    /**
     * A function that is executed before the focused cell changes. Applies only to cells in data or group rows.
     */
    onFocusedCellChanging: PropTypes.func,
    /**
     * A function that is executed after the focused row changes. Applies only to data or group rows. focusedRowEnabled should be true.
     */
    onFocusedRowChanged: PropTypes.func,
    /**
     * A function that is executed before the focused row changes. Applies only to data or group rows. focusedRowEnabled should be true.
     */
    onFocusedRowChanging: PropTypes.func,
    /**
     * A function used in JavaScript frameworks to save the UI component instance
     */
    onInitialized: PropTypes.func,
    /**
     * A function that is executed before a new row is added to the UI component
     */
    onInitNewRow: PropTypes.func,
    /**
     * A function that is executed when the UI component is in focus and a key has been pressed down
     */
    onKeyDown: PropTypes.func,
    /**
     * A function that is executed after a UI component property is changed
     */
    onOptionChanged: PropTypes.func,
    /**
     * A function that is executed when a row is clicked or tapped
     */
    onRowClick: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    /**
     * A function that is executed after a row is collapsed
     */
    onRowCollapsed: PropTypes.func,
    /**
     * A function that is executed before a row is collapsed
     */
    onRowCollapsing: PropTypes.func,
    /**
     * A function that is executed when a row is double-clicked or double-tapped. Executed after onCellDblClick.
     */
    onRowDblClick: PropTypes.func,
    /**
     * A function that is executed after a row is expanded
     */
    onRowExpanded: PropTypes.func,
    /**
     * A function that is executed before a row is expanded
     */
    onRowExpanding: PropTypes.func,
    /**
     * A function that is executed after a new row has been inserted into the data source
     */
    onRowInserted: PropTypes.func,
    /**
     * A function that is executed before a new row is inserted into the data source
     */
    onRowInserting: PropTypes.func,
    /**
     * A function that is executed after a row is created
     */
    onRowPrepared: PropTypes.func,
    /**
     * A function that is executed after a row has been removed from the data source
     */
    onRowRemoved: PropTypes.func,
    /**
     * A function that is executed before a row is removed from the data source
     */
    onRowRemoving: PropTypes.func,
    /**
     * A function that is executed after a row has been updated in the data source
     */
    onRowUpdated: PropTypes.func,
    /**
     * A function that is executed before a row is updated in the data source
     */
    onRowUpdating: PropTypes.func,
    /**
     * A function that is executed after cells in a row are validated against validation rules
     */
    onRowValidating: PropTypes.func,
    /**
     * A function that is executed after row changes are saved
     */
    onSaved: PropTypes.func,
    /**
     * A function that is executed before pending row changes are saved
     */
    onSaving: PropTypes.func,
    /**
     * A function that is executed after selecting a row or clearing its selection
     */
    onSelectionChanged: PropTypes.func,
    /**
     * A function that is executed before the toolbar is created
     */
    onToolbarPreparing: PropTypes.func,
    /**
     * Configures the pager
     */
    pager: PropTypes.object,
    /**
     * Configures paging
     */
    paging: PropTypes.object,
    /**
     * Notifies the DataGrid of the server's data processing operations
     */
    remoteOperations: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    /**
     * Dash event
     */
    removeDroppedRow: PropTypes.object,
    /**
     * Specifies whether to render the filter row, command columns, and columns with showEditorAlways set to true after other elements
     */
    renderAsync: PropTypes.bool,
    /**
     * Specifies whether to repaint only those cells whose data changed
     */
    repaintChangesOnly: PropTypes.bool,
    /**
     * Specifies whether rows should be shaded differently
     */
    rowAlternationEnabled: PropTypes.bool,

    /**
     * Dash event
     */
    rowClick: PropTypes.object,
    /**
     * Dash event
     */
    rowDblClick: PropTypes.object,
    /**
     * Dash event
     */
    rowRemoved: PropTypes.object,
    /**
     * Dash event
     */
    rowRemoving: PropTypes.object,
    /**
     * Dash event
     */
    rowUpdated: PropTypes.object,
    /**
     * Dash event
     */
    rowUpdating: PropTypes.object,

    /**
     * An alias for the rowTemplate property specified in React. Accepts a custom component.
     */
    rowComponent: PropTypes.string,
    /**
     * Configures row reordering using drag and drop gestures
     */
    rowDragging: PropTypes.object,
    /**
     * An alias for the rowTemplate property specified in React. Accepts a rendering function.
     */
    rowTemplate: PropTypes.string,
    /**
     * Switches the UI component to a right-to-left representation
     */
    rtlEnabled: PropTypes.bool,
    /**
     * Configures scrolling
     */
    scrolling: PropTypes.object,
    /**
     * Configures the search panel
     */
    searchPanel: PropTypes.object,
    /**
     * Allows you to select rows or determine which rows are selected. Applies only if selection.deferred is false.
     */
    selectedRowKeys: PropTypes.arrayOf(PropTypes.any),
    /**
     * Configures runtime selection
     */
    selection: PropTypes.object,
    /**
     * Specifies filters for the rows that must be selected initially. Applies only if selection.deferred is true.
     */
    selectionFilter: PropTypes.arrayOf(PropTypes.shape),
    /**
     * Specifies whether the outer borders of the UI component are visible
     */
    showBorders: PropTypes.bool,
    /**
     * Specifies whether column headers are visible
     */
    showColumnHeaders: PropTypes.bool,
    /**
     * Specifies whether vertical lines that separate one column from another are visible
     */
    showColumnLines: PropTypes.bool,
    /**
     * Specifies whether horizontal lines that separate one row from another are visible
     */
    showRowLines: PropTypes.bool,
    /**
     * Allows you to sort groups according to the values of group summary items
     */
    sortByGroupSummaryInfo: PropTypes.arrayOf(PropTypes.object),
    /**
     * Configures runtime sorting
     */
    sorting: PropTypes.object,
    /**
     * Configures state storing
     */
    stateStoring: PropTypes.object,
    /**
     * Specifies the properties of the grid summary
     */
    summary: PropTypes.object,
    /**
     * Specifies the number of the element when the Tab key is used for navigating
     */
    tabIndex: PropTypes.number,
    /**
     * Specifies whether to enable two-way data binding
     */
    twoWayBindingEnabled: PropTypes.bool,
    /**
     * Specifies whether the UI component is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the UI component's width
     */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies whether text that does not fit into a column should be wrapped
     */
    wordWrapEnabled: PropTypes.bool,

    // Dash-assigned callback that gets fired when the value changes.
    setProps: PropTypes.func,
    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
};

DDDataGrid.defaultProps = {
    accessKey: null,
    activeStateEnabled: false,
    allowColumnReordering: false,
    allowColumnResizing: false,
    autoNavigateToFocusedRow: true,
    cacheEnabled: true,
    cellHintEnabled: true,
    columnAutoWidth: false,
    // columnChooser
    // columnFixing
    columnHidingEnabled: false,
    // columnMinWidth
    columnResizingMode: 'nextColumn',
    // columns
    // columnWidth
    // customizeColumns
    dataSource: null,
    // dateSerializationFormat
    disabled: false,
    // editing
    elementAttr: {},
    errorRowEnabled: true,
    // export
    filterBuilder: {},
    filterBuilderPopup: {},
    filterPanel: {},
    // filterRow
    // filterSyncEnabled
    filterValue: null,
    focusedColumnIndex: -1,
    focusedRowEnabled: false,
    focusedRowIndex: -1,
    // focusedRowKey
    focusStateEnabled: false,
    // grouping
    // groupPanel
    // headerFilter
    // height
    highlightChanges: false,
    // hint
    hoverStateEnabled: false,
    // keyboardNavigation: undefined,
    // keyExpr
    // loadPanel
    // masterDetail
    noDataText: 'No data',
    onAdaptiveDetailRowPreparing: null,
    onCellClick: null,
    onCellDblClick: null,
    onCellHoverChanged: null,
    onCellPrepared: null,
    onContentReady: null,
    onContextMenuPreparing: null,
    onDataErrorOccurred: null,
    onDisposing: null,
    onEditCanceled: null,
    onEditCanceling: null,
    onEditingStart: null,
    onEditorPrepared: null,
    onEditorPreparing: null,
    onExporting: null,
    onFocusedCellChanged: null,
    onFocusedCellChanging: null,
    onFocusedRowChanged: null,
    onFocusedRowChanging: null,
    onInitialized: null,
    onInitNewRow: null,
    onKeyDown: null,
    onOptionChanged: null,
    onRowClick: null,
    onRowCollapsed: null,
    onRowCollapsing: null,
    onRowDblClick: null,
    onRowExpanded: null,
    onRowExpanding: null,
    onRowInserted: null,
    onRowInserting: null,
    onRowPrepared: null,
    onRowRemoved: null,
    onRowRemoving: null,
    onRowUpdated: null,
    onRowUpdating: null,
    onRowValidating: null,
    onSaved: null,
    onSaving: null,
    onSelectionChanged: null,
    onToolbarPreparing: null,
    // pager
    // paging
    // remoteOperations
    renderAsync: false,
    repaintChangesOnly: false,
    rowAlternationEnabled: false,
    // rowComponent
    rowDragging: null,
    // rowTemplate
    rtlEnabled: false,
    // scrolling
    // searchPanel
    // selectedRowKeys
    // selection
    selectionFilter: [],
    showBorders: false,
    showColumnHeaders: true,
    showColumnLines: true, // false (Material)
    showRowLines: false, // true (iOS, Material)
    // sortByGroupSummaryInfo
    // sorting
    // stateStoring
    // summary
    tabIndex: 0,
    twoWayBindingEnabled: true,
    visible: true,
    // width
    wordWrapEnabled: false,
};
